module.exports = __webpack_public_path__ + "b3120669bf5b77851a8d2f960c565dcc.pdf";